'use es6';

import { combineReducers } from 'redux';
import SeamlessImmutable from 'seamless-immutable';
import { EMPTY_OBJECT } from 'DesignData/lib/object';
import { LAYOUT_PUBLISH, CUSTOM_WIDGET_BUFFER_PUBLISH, GLOBAL_WIDGET_PUBLISH, TEMPLATE_BUFFER_PUBLISH } from 'DesignData/actions/ActionTypes';

const isPublishAction = action => {
  switch (action.type) {
    case TEMPLATE_BUFFER_PUBLISH:
    case GLOBAL_WIDGET_PUBLISH:
    case CUSTOM_WIDGET_BUFFER_PUBLISH:
    case LAYOUT_PUBLISH:
      return true;

    default:
      return false;
  }
};

const getAssetId = action => action.customWidgetId || action.templateId || action.globalWidgetId || action.layoutId;

const getAsset = action => action.customWidget || action.template || action.globalWidget || action.layout;
/**
 * Publish details.
 */


function publishDetails(state = SeamlessImmutable({
  lastPublishedAt: null
}), action) {
  const asset = getAsset(action);
  if (!asset) return state;
  return SeamlessImmutable.set(state, 'lastPublishedAt', asset.updated);
}
/**
 * Summary details of publishes during session.
 */


function byId(state = EMPTY_OBJECT, action) {
  if (!isPublishAction(action)) {
    return state;
  }

  if (action.error) {
    return state;
  }

  const assetId = getAssetId(action);

  if (!assetId) {
    return state;
  }

  return SeamlessImmutable.set(state, assetId, publishDetails(state[assetId], action));
}

export default combineReducers({
  byId
});